import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { UserSignaturePadModalComponent } from './user-signature-pad-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UserSignaturePadService {
  
  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(signatureOrInitial: boolean) {
    var modalRef!: NgbModalRef;

    modalRef = this.modalService.open( UserSignaturePadModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.signatureOrInitial = signatureOrInitial;
    var sub: Subscription =  modalRef.closed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.signatureModel)
      sub.unsubscribe();
    })
  }
}
